export default __webpack_public_path__ + "static/media/eye - active_v1.b39f5205.svg";